/**
 * Handles the opening and closing of dialogs triggered by elements with the `data-dialog` attribute.
 * @function
 * @returns {void}
 */

import { stopScroll } from "../helpers/stopScroll";

export function handleDialogs() {
    const dialogTriggers = document.querySelectorAll("[data-dialog]");
    const dialogs = document.querySelectorAll("dialog");

    dialogTriggers.forEach((trigger) => {
        trigger.addEventListener("click", function (event) {
            dialogs.forEach((dialog) => {
                dialog.close();
            });
            stopScroll(false);

            const dialogId = event.currentTarget.getAttribute("data-dialog");
            const dialogToOpen = document.getElementById(dialogId);

            if (dialogToOpen) {
                dialogToOpen.showModal();
                stopScroll(true);
            }
        });
    });

    // Listeners inside a dialog
    dialogs.forEach((dialog) => {
        dialog.querySelectorAll("[data-dialog]").forEach((closeButton) => {
            closeButton.addEventListener("click", function () {
                dialog.close();
                stopScroll(false);
            });
        });
    });
}
